module.exports = "/assets/c0ac20f271197e2e2d6419ce7cee2c04.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/S3.png
// module id = 1807
// module chunks = 0